<template>
  <div class="p-3 bg-muted-grey-1 border rounded-lg">
    <div v-for="header in headers" :key="header.id" class="d-flex align-items-end mb-3">
      <div class="flex-grow-1 mr-2">
        <SfeLabel class="mb-1">Key</SfeLabel>
        <SfeInput
          v-model="header.key"
          placeholder="Header Key"
          @input="$emit('update-header', header.id, 'key', header.key)"
        />
      </div>
      <div class="flex-grow-1 mr-2">
        <SfeLabel class="mb-1">Value</SfeLabel>
        <SfeInput
          v-model="header.value"
          placeholder="Header Value"
          @input="$emit('update-header', header.id, 'value', header.value)"
        />
      </div>
      <div class="flex-grow-1">
        <SfeIconButton
            intent="critical"
            variant="outline"
            size="lg"
            @click="$emit('remove-header', header.id)"
            aria-label="Remove header"
        >
          <i class="material-icons">delete</i>
        </SfeIconButton>
      </div>
    </div>
    <SfeButton
      variant="outline"
      size="sm"
      @click="$emit('add-header')"
      class="mt-2"
    >
      + Add New Header
    </SfeButton>
  </div>
</template>

<script>
export default {
  props: ['headers']
}
</script>
